<template>
  <Logo height="14" :alt="$tBrand('logo.alt')" />
</template>

<script>
/**
 * The instance logo as shown in the sidebar foot and the table header.
 *
 * Upstream wraps this in an `<a href="https://baserow.io">` carrying a
 * hardcoded "open source no-code database tool" title. This deployment serves
 * its own brand, so the outbound attribution link is deliberately gone and only
 * the logo itself remains -- `<Logo>` already resolves to the per-instance
 * `co_branding_logo` when one is set.
 *
 * The component keeps its name and its wrapping element so the existing
 * `.sidebar__logo img` and `.header__filter-logo` rules, which size the logo by
 * height for an unknown aspect ratio, keep applying unchanged.
 */
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
